import i18n from 'i18next'
import { APP_LINK } from '@constants'
import { getLocaleFromPath, normalizeLocale, withLocale } from './localePath'

/**
 * Builds a product URL carrying the funnel's current language, so a user handed over
 * after checkout lands in the app in the language they were onboarded in.
 * The path locale wins over i18n's active language, matching how the funnel resolves it.
 */
export function getAppLink(path = '', search = ''): string {
  const locale = getLocaleFromPath(window.location.pathname) ?? normalizeLocale(i18n.language)

  return `${APP_LINK}${withLocale(path, locale)}${search}`
}
